@if (isLoading) {
<div class="panel-title-dummy">
  <div class="shine"></div>
</div>
<div class="panel-dummy">
  <div class="shine"></div>
</div>
<div class="panel-dummy">
  <div class="shine"></div>
</div>
<div class="panel-dummy">
  <div class="shine"></div>
</div>
}
@else {
<h2 class="panel-title">{{('Modules.XPACManagementComponent.XpacTelemetryComponent.Title' | translate)}}</h2>

<div *ngIf="telemetry.length" class="padding-list">
  <ng-container *ngFor="let log of telemetry">
    <app-list-item title="{{ log.message }}" [info]="getInfoString(log)" [info2]="getSecondaryInfoString(log)">
    </app-list-item>
  </ng-container>

  <div class="action-buttons">
    <ng-container *ngIf="isLoadingMore; then loading else loadAction"></ng-container>

    <ng-template #loadAction>
      <button mat-flat-button class="button small-button" (click)="loadMore()" [disabled]="!hasMore">
        <mat-icon>update</mat-icon>
        <p>{{ 'General.LoadMore' | translate }}</p>
      </button>
    </ng-template>

    <ng-template #loading>
      <mat-spinner class="spinner" diameter="28"></mat-spinner>
    </ng-template>
  </div>
</div>

<ng-container *ngIf="!telemetry.length">
  <p class="p-form-group">{{ 'Modules.XPACManagementComponent.XpacTelemetryComponent.NoTelemetry' | translate }}</p>
</ng-container>
}